import { render, staticRenderFns } from "./OrmBatchingAvailableQuotes2.vue?vue&type=template&id=35e3ea27&scoped=true"
import script from "./OrmBatchingAvailableQuotes2.vue?vue&type=script&lang=js"
export * from "./OrmBatchingAvailableQuotes2.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingAvailableQuotes2.vue?vue&type=style&index=0&id=35e3ea27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3ea27",
  null
  
)

export default component.exports